module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_302958.9e40653a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetATF/FormatoSimplificado_302958.pdf
// module id = 325
// module chunks = 0